import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';

export const getSendGridDynamicTemplate = async (templateId: string) => {
  const response = await queryExecute({
    fetchPolicy: 'no-cache',
    variables: {
      id: templateId,
    },
    query: graphql(`
      query GetSendGridDynamicTemplate($id: String!) {
        getSendGridDynamicTemplate(id: $id) {
          id
          name
          htmlContent
        }
      }
    `),
  });

  return response.data.getSendGridDynamicTemplate;
};
